exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myuser[data-v-32590e1e]{margin-right:20px}.dropdown-menu[data-v-32590e1e]{left:-45px}.myuser a[data-v-32590e1e]{color:#fff;font-size:15px}.user-header[data-v-32590e1e]{padding:10px;margin-bottom:5px;width:100%}.user-header p[data-v-32590e1e]{color:#fff;font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/header/User.vue?vue&type=style&index=0&id=32590e1e&prod&scoped=true&lang=css&
// module id = 891
// module chunks = 0